import { render, staticRenderFns } from "./contact-history.vue?vue&type=template&id=0b4807da&scoped=true&"
import script from "./contact-history.vue?vue&type=script&lang=js&"
export * from "./contact-history.vue?vue&type=script&lang=js&"
import style0 from "./contact-history.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./contact-history.vue?vue&type=style&index=1&id=0b4807da&lang=scss&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0b4807da",
  null
  
)

export default component.exports